import { siteConfig } from '@/mocks/site';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-xl font-bold">
              {siteConfig.logo}
            </span>
            <span className={`font-heading text-lg font-semibold transition-colors duration-300 ${isScrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              {siteConfig.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/zixing-yanbian"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              字形演变
            </Link>
            <Link
              to="/category/yuyi-jiexi"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              语义解析
            </Link>
            <Link
              to="/category/guji-yongli"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              古籍用例
            </Link>
            <Link
              to="/category/wenhua-yanjiu"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              文化研究
            </Link>
            <Link
              to="/category/xiandai-yujing"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              现代语境
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              isScrolled ? 'text-foreground-800' : 'text-background-50'
            }`}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>首页</Link>
            <Link to="/category/zixing-yanbian" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>字形演变</Link>
            <Link to="/category/yuyi-jiexi" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>语义解析</Link>
            <Link to="/category/guji-yongli" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>古籍用例</Link>
            <Link to="/category/wenhua-yanjiu" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>文化研究</Link>
            <Link to="/category/xiandai-yujing" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>现代语境</Link>
            <Link to="/about" className="block px-4 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md whitespace-nowrap cursor-pointer" onClick={() => setIsMobileOpen(false)}>关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}